<router-outlet></router-outlet>
<!-- <div style="position: fixed; right: 0; top: 0">
  <button routerLink="auth">auth</button>
  <button routerLink="">cabinet</button>
</div> -->
